
const News = () => {
  
  return (
	<section id='news' className='px-2 py-3 pb-10 bg-teal-600 text-white'>
		<div className="container mx-auto my-3">
			<h2 className='w-fit mx-auto text-4xl border-b-2 border-amber-500 mb-6 uppercase'>
          		Aktuality
        	</h2>
			<div className="md:w-3/4 px-4 md:px-0 mx-auto text-lg md:text-xl" >
	
				
				<p className="">
					Děkujeme firmě <span className="font-bold text-amber-500">Lukas CZ, spol. s r. o.</span>, Skalná za poskytnutí finančního daru určenému jako příspěvek na dárky pro naše jubilanty. Vážíme si této pomoci a věříme, že naši klienti budou potěšeni.
				</p>
			</div>
		</div>
    </section>
  )
}

export default News
